var map = {
	"./AvenirLTStd-Roman.woff": "La9y",
	"./annie.jpg": "RXaC",
	"./cross.svg": "boHS",
	"./delete.svg": "TpOy",
	"./edit.svg": "3X5m",
	"./logo.png": "7Otq",
	"./ludwig.jpg": "jytC",
	"./mamma.jpg": "aHN+",
	"./pappa.jpg": "FP3U",
	"./power.svg": "JO0x",
	"./save.svg": "PENx",
	"./simon.jpg": "SJCn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dafD";


//////////////////
// WEBPACK FOOTER
// ./src/assets $
// module id = dafD
// module chunks = 1